import { render } from "./MessageModal.vue?vue&type=template&id=3a6f920c&scoped=true"
import script from "./MessageModal.vue?vue&type=script&lang=js"
export * from "./MessageModal.vue?vue&type=script&lang=js"

import "./MessageModal.vue?vue&type=style&index=0&id=3a6f920c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6f920c"]])

export default __exports__